import { render, staticRenderFns } from "./employeeDocumentModal.vue?vue&type=template&id=13f6dab9&"
import script from "./employeeDocumentModal.vue?vue&type=script&lang=js&"
export * from "./employeeDocumentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports